
import { Component, Prop, Vue } from 'vue-property-decorator';
import { copyToClipboard } from '~common-helpers';

@Component
export default class CopyElementWrapper extends Vue {
    @Prop() readonly value!: string;

    copyToClipboard() {
        copyToClipboard(this.value);
    }
}
